module.exports = __webpack_public_path__ + "media/packs/user-cards/images/failure-896ceb37f7e7ed4dc5bb3d970a6503fd.svg";